/* Me Zemër product page (mz-pdp.js): gallery, zoom, quantity, add to cart, box options, waitlist, bundle, rows. Loaded by sections/mz-product.liquid. */
(function () {
  'use strict';
  if (window.__mzPdp) return;
  window.__mzPdp = true;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function money(cents) {
    var fmt = '${{amount}}';
    try { var st = JSON.parse(document.getElementById('mz-state').textContent); if (st.money) fmt = st.money; } catch (e) {}
    var n = (cents / 100).toFixed(2);
    var parts = n.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var amount = whole + '.' + parts[1];
    return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/, whole)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1])
      .replace(/\{\{\s*\w+\s*\}\}/, amount);
  }

  function openCart() {
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.show === 'function') { drawer.show(); return; }
    var link = document.querySelector('a[aria-controls="cart-drawer"], a[href$="/cart"][aria-controls]');
    if (link) link.click(); else window.location.href = root + 'cart';
  }

  function addItems(items) {
    return fetch(root + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart'); return j; }); });
  }

  $$('[data-mz-pdp]').forEach(function (pdp) {
    /* Gallery: swipe track, arrows, thumbnails */
    var track = $('[data-mz-gal-track]', pdp);
    var thumbs = $$('[data-mz-thumb]', pdp);
    if (track) {
      var slides = $$('.mz-gal__slide', track);
      var prevB = $('[data-mz-gal-prev]', pdp), nextB = $('[data-mz-gal-next]', pdp);
      var padL = function () { return parseFloat(getComputedStyle(track).paddingLeft) || 0; };
      var go = function (i) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        if (slides[i]) track.scrollTo({ left: slides[i].offsetLeft - padL(), behavior: 'smooth' });
      };
      var current = function () {
        var x = track.scrollLeft + padL(), best = 0, d = Infinity;
        slides.forEach(function (s, k) { var dd = Math.abs(s.offsetLeft - x); if (dd < d) { d = dd; best = k; } });
        return best;
      };
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { go(parseInt(t.getAttribute('data-mz-thumb'), 10)); });
      });
      if (prevB) prevB.addEventListener('click', function () { go(current() - 1); });
      if (nextB) nextB.addEventListener('click', function () { go(current() + 1); });
      var tick = null;
      var sync = function () {
        var i = current();
        thumbs.forEach(function (t, j) { t.classList.toggle('is-active', j === i); });
        var on = thumbs[i];
        if (on && on.parentNode.scrollWidth > on.parentNode.clientWidth) on.parentNode.scrollTo({ left: on.offsetLeft - 16, behavior: 'smooth' });
        if (prevB) prevB.disabled = i === 0;
        if (nextB) nextB.disabled = i >= slides.length - 1;
        $$('video', track).forEach(function (v) { if (!v.paused) v.pause(); });
      };
      track.addEventListener('scroll', function () {
        if (tick) return;
        tick = requestAnimationFrame(function () { tick = null; sync(); });
      }, { passive: true });
      sync();
    }

    /* Desktop: the top fills the screen under the header, so the button bar sits at the fold */
    var heroEl = $('[data-mz-hero]', pdp);
    var setH = function () {
      if (!heroEl) return;
      if (window.innerWidth < 990) { pdp.style.removeProperty('--mz-hero-h'); return; }
      var top = heroEl.getBoundingClientRect().top + window.scrollY;
      pdp.style.setProperty('--mz-hero-h', Math.max(560, Math.min(960, window.innerHeight - top)) + 'px');
    };
    setH();
    window.addEventListener('resize', setH);

    /* Button bar: on phones it slides up while the top of the page is on screen */
    var bar = $('[data-mz-bar]', pdp), hero = $('[data-mz-hero]', pdp);
    if (bar && hero && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { bar.classList.toggle('is-shown', en[0].isIntersecting); }, { rootMargin: '0px 0px -10% 0px' }).observe(hero);
    } else if (bar) { bar.classList.add('is-shown'); }

    /* Zoom */
    var dlg = $('[data-mz-zoom-dlg]', pdp);
    var zimg = $('[data-mz-zoom-img]', pdp);
    pdp.addEventListener('click', function (e) {
      var b = e.target.closest('[data-mz-zoom]');
      if (!b || !dlg) return;
      zimg.src = b.getAttribute('data-mz-zoom');
      zimg.alt = ($('img', b) || {}).alt || '';
      if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
      document.documentElement.classList.add('mz-noscroll');
    });
    if (dlg) {
      var close = function () { if (dlg.open) dlg.close(); document.documentElement.classList.remove('mz-noscroll'); };
      $('[data-mz-zoom-close]', dlg).addEventListener('click', close);
      dlg.addEventListener('close', function () { document.documentElement.classList.remove('mz-noscroll'); });
      dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
      zimg.addEventListener('click', function () { dlg.classList.toggle('is-big'); });
    }

    /* Quantity */
    pdp.addEventListener('click', function (e) {
      var q = e.target.closest('[data-mz-qty]');
      if (!q) return;
      var input = $('.mz-qty__in', q.parentNode);
      var n = Math.max(1, Math.min(99, (parseInt(input.value, 10) || 1) + parseInt(q.getAttribute('data-mz-qty'), 10)));
      input.value = n;
    });

    /* Variant select */
    var vsel = $('[data-mz-variant-select]', pdp);
    if (vsel) vsel.addEventListener('change', function () {
      $('[data-mz-variant]', pdp).value = vsel.value;
      var o = vsel.options[vsel.selectedIndex];
      var now = $('[data-mz-price-now]', pdp);
      if (now && o) now.textContent = o.getAttribute('data-price');
      var bp = $('[data-mz-add-price]', pdp);
      if (bp && o) bp.textContent = o.getAttribute('data-price');
    });

    /* Box options */
    var opts = $('[data-mz-opts]', pdp);
    var addLabel = $('[data-mz-add-label]', pdp);
    function syncOpts() {
      if (!opts) return;
      $$('.mz-opt', opts).forEach(function (o) {
        var r = $('input[name="mz-mode"]', o);
        o.classList.toggle('is-on', r.checked);
        if (r.checked && addLabel) addLabel.textContent = r.getAttribute('data-btn');
        if (r.checked && r.getAttribute('data-price')) {
          var bp = $('[data-mz-add-price]', pdp), pn = $('[data-mz-price-now]', pdp);
          if (bp) bp.textContent = r.getAttribute('data-price');
          if (pn) pn.textContent = r.getAttribute('data-price');
        }
      });
      var mode = (($('input[name="mz-mode"]:checked', opts) || {}).value) || 'once';
      $$('[name="selling_plan"]', opts).forEach(function (i) { i.disabled = mode !== 'sub'; });
    }
    if (opts && /[?&]gift=1/.test(location.search)) {
      var giftR = $('input[name="mz-mode"][value="gift"]', opts);
      if (giftR) giftR.checked = true;
    }
    if (opts) { opts.addEventListener('change', syncOpts); syncOpts(); }

    /* Add to cart */
    var form = $('[data-mz-buy]', pdp);
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var err = $('[data-mz-err]', form);
        var ageErr = $('[data-mz-age-err]', form);
        var age = $('[data-mz-age]', form);
        err.hidden = true;
        if (age && !age.checked) { ageErr.hidden = false; age.focus(); return; }
        if (ageErr) ageErr.hidden = true;
        var btn = $('[data-mz-add]', form);
        var item = { id: parseInt($('[data-mz-variant]', form).value, 10), quantity: 1 };
        var qty = $('input[name="quantity"]', form);
        if (qty) item.quantity = Math.max(1, parseInt(qty.value, 10) || 1);
        var mode = opts ? ((($('input[name="mz-mode"]:checked', opts) || {}).value) || 'once') : 'once';
        if (mode === 'sub') {
          var plan = $('select[name="selling_plan"], input[name="selling_plan"]:checked', opts);
          if (plan && plan.value) item.selling_plan = parseInt(plan.value, 10);
        }
        var props = {};
        if (age) props._age_confirmed = 'yes';
        if (mode === 'gift') {
          props['Gift'] = 'Yes, no prices inside';
          var note = $('[data-mz-gift-note]', pdp);
          if (note && note.value.trim()) props['Gift note'] = note.value.trim();
        }
        if (Object.keys(props).length) item.properties = props;
        btn.disabled = true; btn.classList.add('is-loading');
        addItems([item]).then(openCart).catch(function (x) { err.textContent = x.message; err.hidden = false; })
          .then(function () { btn.disabled = false; btn.classList.remove('is-loading'); });
      });
      var ageBox = $('[data-mz-age]', form);
      if (ageBox) ageBox.addEventListener('change', function () { if (ageBox.checked) $('[data-mz-age-err]', form).hidden = true; });
    }

    /* Waitlist, in place */
    var wl = $('[data-mz-wl]', pdp);
    if (wl) {
      var open = $('[data-mz-wl-open]', wl), panel = $('[data-mz-wl-panel]', wl), wform = $('[data-mz-wl-form]', wl);
      open.addEventListener('click', function () {
        var show = panel.hidden;
        panel.hidden = !show;
        open.setAttribute('aria-expanded', String(show));
        if (show) { var em = $('input[type="email"]', panel); if (em) em.focus(); }
      });
      if (wform) wform.addEventListener('submit', function (e) {
        e.preventDefault();
        var em = $('input[type="email"]', wform), err = $('[data-mz-wl-err]', wform), tags = $('[data-mz-wl-tags]', wform), optin = $('[data-mz-wl-optin]', wform);
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((em.value || '').trim())) { err.textContent = em.validationMessage || 'Please enter a valid email address.'; err.hidden = false; em.focus(); return; }
        err.hidden = true;
        if (!tags.getAttribute('data-base')) tags.setAttribute('data-base', tags.value);
        tags.value = tags.getAttribute('data-base') + ', ' + (optin && optin.checked ? 'newsletter' : 'waitlist-only');
        var b = $('button[type="submit"]', wform); b.disabled = true;
        fetch(wform.getAttribute('action') || root + 'contact', { method: 'POST', body: new FormData(wform), credentials: 'same-origin', headers: { 'Accept': 'text/html' } })
          .then(function (res) {
            if (/\/challenge/.test(res.url)) { HTMLFormElement.prototype.submit.call(wform); return; }
            wform.hidden = true; $('[data-mz-wl-done]', wl).hidden = false;
          })
          .catch(function () { HTMLFormElement.prototype.submit.call(wform); })
          .then(function () { b.disabled = false; });
      });
      if (/customer_posted=true/.test(location.search)) { panel.hidden = false; if (wform) wform.hidden = true; $('[data-mz-wl-done]', wl).hidden = false; }
    }

    /* Pairs Well With: this product (always in) + picks. Lines, discount and the button price update together. */
    $$('[data-mz-bundle]', pdp).forEach(function (bd) {
      var boxes = $$('[data-mz-b-item]', bd);
      var self = $('[data-mz-b-item][data-self]', bd);
      var picks = boxes.filter(function (b) { return b !== self; });
      var tiers = (bd.getAttribute('data-tiers') || '').split(',').map(function (t) { var p = t.split('='); return [parseInt(p[0], 10), parseFloat(p[1])]; }).filter(function (t) { return t[0] > 0 && t[1] > 0; }).sort(function (a, b) { return a[0] - b[0]; });
      var q = function (s) { return $(s, bd); };
      var price = function (b) { return parseInt(b.getAttribute('data-price'), 10) || 0; };
      function upd() {
        var on = boxes.filter(function (b) { return b.checked; });
        var onPicks = picks.filter(function (b) { return b.checked; });
        var selfP = self ? price(self) : 0;
        var pairsP = onPicks.reduce(function (s, b) { return s + price(b); }, 0);
        var offer = on.filter(function (b) { return b.getAttribute('data-offer') === 'true'; });
        var pct = 0;
        tiers.forEach(function (t) { if (offer.length >= t[0]) pct = t[1]; });
        var disc = pct ? Math.round(offer.reduce(function (s, b) { return s + price(b); }, 0) * pct / 100) : 0;
        var total = selfP + pairsP - disc;
        q('[data-mz-b-self]').textContent = money(selfP);
        var pl = q('[data-mz-b-pairs-label]');
        pl.textContent = onPicks.length === 1 ? pl.getAttribute('data-one') : pl.getAttribute('data-many').replace('[n]', onPicks.length);
        q('[data-mz-b-pairs]').textContent = money(pairsP);
        q('[data-mz-b-pairs-row]').hidden = onPicks.length === 0;
        q('[data-mz-b-disc-row]').hidden = !disc;
        q('[data-mz-b-disc-label]').textContent = (bd.getAttribute('data-save') || '').replace('[pct]', pct);
        q('[data-mz-b-disc]').textContent = disc ? '\u2212' + money(disc) : '';
        var note = q('[data-mz-b-note]'); if (note) note.hidden = !disc;
        q('[data-mz-b-sum]').textContent = money(total);
        var all = on.length === boxes.length;
        q('[data-mz-b-label]').textContent = (bd.getAttribute(all ? 'data-btn-all' : 'data-btn-some') || '').replace('[n]', on.length);
        q('[data-mz-b-btn-price]').textContent = money(total);
        boxes.forEach(function (b) { b.closest('.mz-bundle__card').classList.toggle('is-off', !b.checked); });
      }
      picks.forEach(function (b) { b.addEventListener('change', upd); });
      upd();
      var btn = q('[data-mz-b-add]'), err = q('[data-mz-b-err]');
      btn.addEventListener('click', function () {
        var age = $('[data-mz-age]', pdp);
        if (age && !age.checked) { var ae = $('[data-mz-age-err]', pdp); if (ae) ae.hidden = false; age.scrollIntoView({ block: 'center', behavior: 'smooth' }); age.focus({ preventScroll: true }); return; }
        var items = boxes.filter(function (b) { return b.checked; }).map(function (b) { var it = { id: parseInt(b.getAttribute('data-variant'), 10), quantity: 1 }; if (age) it.properties = { _age_confirmed: 'yes' }; return it; });
        btn.disabled = true; err.hidden = true;
        addItems(items).then(openCart).catch(function (x) { err.textContent = x.message; err.hidden = false; }).then(function () { btn.disabled = false; });
      });
      /* "Bundle & Save" under the buy button jumps here instead of leaving the page */
      $$('.mz-bar__link', pdp).forEach(function (a) {
        if (pdp.getAttribute('data-kind') === 'box') return;
        a.setAttribute('href', '#' + (bd.id || 'pairs'));
        a.addEventListener('click', function (e) {
          e.preventDefault();
          var top = bd.getBoundingClientRect().top + window.scrollY - 90;
          window.scrollTo({ top: top, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        });
      });
    });

    /* Rows with arrows */
    $$('[data-mz-row]', pdp).forEach(function (row) {
      var tr = $('[data-mz-row-track]', row), prev = $('[data-mz-row-prev]', row), next = $('[data-mz-row-next]', row);
      function step(dir) { tr.scrollBy({ left: dir * Math.max(240, tr.clientWidth * 0.8), behavior: 'smooth' }); }
      function upd() {
        prev.disabled = tr.scrollLeft < 4;
        next.disabled = tr.scrollLeft + tr.clientWidth >= tr.scrollWidth - 4;
      }
      prev.addEventListener('click', function () { step(-1); });
      next.addEventListener('click', function () { step(1); });
      tr.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd);
      upd();
    });
  });
})();
